export default "__VITE_ASSET__DUchuXXu__"